// Module
var code = "<home-dashboard-new ng-if=\"$ctrl.newDashboardEnabled\"></home-dashboard-new><home-dashboard-old ng-if=\"$ctrl.oldDashboardEnabled\"></home-dashboard-old>";
// Exports
module.exports = code;